<template>
  <div class="cases mt-3">
    <b-card no-body class="p-3" v-for="item in casesList" :key="item.case_id" >
      <b-row align-h="between">
        <b-col cols="12" md="auto">
          <div class="d-flex justify-content-start align-items-center">
            <h3 class="mb-0 text-primary mr-2">ID: {{ item.case_no }}</h3>
						<span class="rounded text-white px-1 mx-2" :class="_gConst.getBgColor(item.loan_type_code)" >{{ item.loan_type_name }}</span>
          </div>
        </b-col>
        <b-col cols="12" md="auto">
          <div class="d-md-flex justify-content-between align-items-center">
            <p class="text-success">{{ getStatusName(item.status_id) }}</p>
            <b-icon icon="dot" scale="2" class="text-light d-none d-md-block"></b-icon>
            <p class="text-gray">Created on {{ item.created_at | dateFormatString }}</p>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="3" class="border-right">
          <b-row>
            <b-col cols="12" md="12" class="p-1">
              <div class="card mb-0 h-100 p-3 shadow-none">
                <div>
                  <p class="text-muted text-xs">Status</p>
									<p class="font-weight-600">{{ item.status_detail.name || "-" }}</p>
                  <!-- <el-dropdown trigger="click" v-model="customerStatus" style="cursor: pointer;">
                    <p class="el-dropdown-link top-line">
                      <span :class="getClockIconColor('yellow')" class="d-inline-block text-truncate font-weight-600"
                        style="max-width: 150px; overflow: unset;">LO-Presign</span>
                      <i class="el-icon-caret-bottom el-icon--right"></i>
                    </p>
                    <el-dropdown-menu slot="dropdown">
                      <div style="max-height: 300px;overflow-y: auto;">
                        <el-dropdown-item v-for="status in mainStatusList" :key="status.status_id"
                          @click.native="updateCustomerStatus(scope.row, status.status_id)">{{ status.status}}
                        </el-dropdown-item>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown> -->
                </div>
                <div>
                  <p class="text-muted text-xs">Loan Amount</p>
                  <p class="font-weight-600">RM {{ item.loan_amount | moneyFormatter }}</p>
                </div>
                <div>
                  <p class="text-muted text-xs">Total Interest Amt. (Tenure)</p>
                  <p class="font-weight-600">RM {{ item.total_interest_amt | moneyFormatter }} ({{ item.loan_tenure }} {{ item.loan_tenure_period }})</p>
                </div>
                <div>
                  <p class="text-muted text-xs">Total Installment Amount</p>
                  <p class="font-weight-600">RM {{ item.total_instalment_amt | moneyFormatter }}</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="9">
          <b-row>
            <b-col cols="12" md="4" class="p-1">
              <div class="card mb-0 h-100 p-3 shadow-none">
                <div class="border-bottom mb-1">
                  <p class="font-weight-500 mb-2">Disbursement</p>
                </div>
                <div>
                  <p class="text-muted text-xs">Disbursement Status</p>
                  <p class="font-weight-600 text-warning">{{ _gHlp.getValue(item,'disb_status_detail.name','-') }}</p>
                </div>
                <div>
                  <p class="text-muted text-xs">Total Disbursed Amount</p>
                  <p class="font-weight-600">RM {{ item.disb_total_amt | moneyFormatter }}</p>
                </div>
                <div>
                  <p class="text-muted text-xs">Latest Disbursed Date</p>
                  <p class="font-weight-600">{{ _gHlp.formatMomentDate(item.disb_tat_date, 'D MMM, YYYY') }}</p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4" class="p-1">
              <div class="card mb-0 h-100 p-3 shadow-none">
                <div class="border-bottom mb-1">
                  <p class="font-weight-500 mb-2">Collection</p>
                </div>
                <div>
                  <p class="text-muted text-xs" style="font-size: 11px;">Total Paid Amount</p>
                  <p class="font-weight-600">RM {{ item.coll_total_paid_amt | moneyFormatter }}</p>
                </div>
                <div>
                  <p class="text-muted text-xs" style="font-size: 11px;">Outstanding Balance</p>
                  <p class="font-weight-600">RM {{ item.coll_outstanding_bal | moneyFormatter }}</p>
                </div>
                <div>
                  <p class="text-muted text-xs" style="font-size: 11px;">Next Payment (Due Date)</p>
                  <p class="font-weight-600">RM {{ item.coll_next_payment_amt | moneyFormatter }} ({{ _gHlp.formatMomentDate(item.coll_due_date, 'D MMM, YYYY') }})</p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4" class="p-1">
              <div class="card h-100 p-3 shadow-none">
                <div class="border-bottom mb-1">
                  <p class="font-weight-500 mb-2">Redemption</p>
                </div>
                <div>
                  <p class="text-muted text-xs" style="font-size: 11px;">Settlement Status</p>
                  <p class="font-weight-600 text-warning">{{ item.status || '-' }}</p>
                </div>
                <div>
                  <p class="text-muted text-xs" style="font-size: 11px;">Actual Settlement Amt.</p>
                  <p class="font-weight-600" :class="{'text-danger': item.settlement_actual_amt < 0}">
                    RM {{ item.settlement_actual_amt | moneyFormatter }}
                  </p>
                </div>
                <div>
                  <p class="text-muted text-xs" style="font-size: 11px;">Facility Type</p>
                  <p class="font-weight-600">{{ item.facility_type || '-' }}</p>
                </div>
              </div>
            </b-col>
            <b-col cols="12" class="p-1">
              <div class="text-right p-2">
								<el-button v-if="!_gHlp.isEmpty(item.loan_ec_id)" type="info" class="mx-1" size="mini" @click="$refs.drawer_detail_loan_ec.show(item.customer_id,item.loan_ec_id)"> View Loan Eligible</el-button>
								<el-button type="warning" class="mx-1" size="mini" @click="viewSettlement(item)">View Settlements</el-button>
								<el-button type="primary" class="mx-1" size="mini" @click="viewDetail(item)">View Detail Case</el-button>
							</div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

		<DrawerDetailLoanEc ref="drawer_detail_loan_ec"/>
		<DrawerSettlement ref="drawer_settlement_details" />
  </div>
</template>
<script>
import { Card, Button, Tag, Timeline, TimelineItem, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import DrawerDetailLoanEc from '@/views/CustomerProfile/Drawers/DrawerLoanEc/DrawerDetailLoanEc'
import DrawerSettlement from '@/views/CreditLoanCase/Drawers/DrawerSettlement'

import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCommonStore } from '@/stores/commonStore';

export default {
  props: ['customer'],
  name: 'cases',
  components: {
		DrawerDetailLoanEc,
		DrawerSettlement,
    [Card.name]: Card,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Timeline.name]: Timeline,
    [TimelineItem.name]: TimelineItem,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      customerStatus: '',
			mainStatusList: [
        {
          status_id: 1,
          status: 'Settlement Stage',
        },
        {
          status_id: 2,
          status: 'LA Stage',
        },
        {
          status_id: 3,
          status: 'Restructured',
        },
      ],
      casesList: []
    };
  },
  created() {
    // this.getList();
  },
  computed: {
    ...mapState(useCustomerStore, ['activeCustomer']),
		...mapState(useCommonStore, ['allStatus']),
    activities() {
      return [
        {
          content: 'Profile',
          timestamp: 'Profile information has been filled out.',
          size: 'large',
          color: '#0bc196',
          icon: 'el-icon-check',
        },
        {
          content: 'Net Income',
          timestamp: 'Net income has been filled out.',
          size: 'large',
          color: '#0bc196',
          icon: '',
        },
        {
          content: 'Commitment',
          timestamp: 'Latest CTOS report has been generated on 30 Jan 2023'
          ,
          color: this.current_commitment ? '#0bc196' : '',
          icon: this.current_commitment ? 'el-icon-check' : '',
          size: 'large',
          color: '#0bc196',
        },
        {
          content: 'Loan Eligibility Calculator',
          timestamp: 'Only can be unlocked once Net Income & Commitment are added.'
          ,
          size: 'large',
          color: '',
        },
      ]
    },
		caseStatusList(){
			return (!_gHlp.isEmpty(this.allStatus)) ?	 this.allStatus.filter(itm => itm.module == 'case') : [];
		}
  },
	watch: {
		'activeCustomer': {
			handler(newValue, oldValue) {
				if(!_gHlp.isEmpty(newValue)){
					this.getList();
				}else{
					this.casesList = [];
				}
			},
			immediate: true
		}
	},
	methods: {
    ...mapActions(useLoanCaseStore, ['getCaseList','getCase','getDisbList']),
    ...mapActions(useCommonStore, ['getLoanType']),
		getStatusName(status_id) {
			let sts = this.caseStatusList.find(itm => itm.id == status_id);
			return (!_gHlp.isEmpty(sts)) ? sts.name : '-';
		},
    getList() {
      const params = {
				search:{
					customer_id: this.activeCustomer.id
				}
      }
      this.getCaseList(params).then((resp) => {
        this.casesList = resp.data;
      });
    },
    viewDetail(loanCase) {
      this.getCase(loanCase.case_id).then(res => {
        this.$router.push('/credit-loan-case/detail/'+loanCase.case_id+'?active=overview');
      });
    },
    viewSettlement(loanCase) {
			this.$refs.drawer_settlement_details.show(_gHlp.getValue(loanCase,'customer_id'),_gHlp.getValue(loanCase,'case_id'),_gHlp.getValue(loanCase,'disb_status_detail.name',null));
    }
  },
}
</script>